/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const iotex_chain_about = () => `IoTeX is a blockchain platform designed specifically for the Internet of Things (IoT) industry. It aims to address the scalability, privacy, and security challenges associated with connecting billions of devices to the internet. IoTeX utilizes a unique architecture that combines blockchain, decentralized identity, and secure hardware to create a trusted and privacy-centric infrastructure for IoT applications. It offers lightweight and efficient consensus mechanisms, support for trusted computing environments, and privacy-preserving techniques such as zero-knowledge proofs.`
